import { defineMessages } from 'react-intl';

const scope = 'app.containers.TipDirectPages.TourPhotos';

export default defineMessages({
  title: { id: `${scope}.title`, defaultMessage: 'Tour photos' },

  announceTitle: { id: `${scope}.announceTitle`, defaultMessage: 'Before you start' },
  announceBody: {
    id: `${scope}.announceBody`,
    defaultMessage:
      'Tell your group at the start of the tour. It takes ten seconds and it is the fairest way to do this.'
  },
  announceScript: {
    id: `${scope}.announceScript`,
    defaultMessage:
      '“I’ll take a few group photos you can grab at the end. If you’d rather not be in them, just tell me.”'
  },
  announceAck: { id: `${scope}.announceAck`, defaultMessage: 'I’ve told my group' },

  blankSlateTitle: {
    id: `${scope}.blankSlateTitle`,
    defaultMessage: 'Start your tour gallery'
  },
  blankSlateBody: {
    id: `${scope}.blankSlateBody`,
    defaultMessage:
      'Take a few photos during the tour. At the end, show your guests the QR code and they can pick them up.'
  },

  takePhoto: { id: `${scope}.takePhoto`, defaultMessage: 'Take a photo' },
  addPhotos: { id: `${scope}.addPhotos`, defaultMessage: 'Add photos' },
  remaining: {
    id: `${scope}.remaining`,
    defaultMessage: '{count} more photos can be added'
  },
  full: { id: `${scope}.full`, defaultMessage: 'That’s all 8 photos for this tour' },
  someRejected: {
    id: `${scope}.someRejected`,
    defaultMessage: '{count} photos were not added. A tour can hold 8.'
  },

  showGuests: { id: `${scope}.showGuests`, defaultMessage: 'Show this to your guests' },
  showGuestsBody: {
    id: `${scope}.showGuestsBody`,
    defaultMessage:
      'They scan it to get their photos, and can tip or review you from the same page.'
  },

  newTour: { id: `${scope}.newTour`, defaultMessage: 'Start a new tour' },
  newTourConfirmTitle: {
    id: `${scope}.newTourConfirmTitle`,
    defaultMessage: 'Start a new tour?'
  },
  newTourConfirmBody: {
    id: `${scope}.newTourConfirmBody`,
    defaultMessage:
      'Your guests keep their link, but you will no longer be able to see these photos. This is on purpose.'
  },
  newTourConfirmAction: {
    id: `${scope}.newTourConfirmAction`,
    defaultMessage: 'Start new tour'
  },
  cancel: { id: `${scope}.cancel`, defaultMessage: 'Cancel' },

  uploadFailed: { id: `${scope}.uploadFailed`, defaultMessage: 'Didn’t send' },
  retry: { id: `${scope}.retry`, defaultMessage: 'Retry' },
  discard: { id: `${scope}.discard`, defaultMessage: 'Discard' },
  loadFailed: {
    id: `${scope}.loadFailed`,
    defaultMessage: 'We could not load your tour photos.'
  },
  loading: { id: `${scope}.loading`, defaultMessage: 'Loading your tour photos' }
});
